import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  add(event) {
    event.preventDefault()
    const wrapper = document.createElement("div")
    wrapper.classList.add("flex", "items-center", "gap-2", "mb-2")
    wrapper.innerHTML = `
      <input type="text" name="article[tag_list][]" maxlength="255" class="border rounded px-2 py-1" list="tag-suggestions" autocomplete="off" />
      <button type="button" data-action="tags#remove" class="text-red-500 font-bold hover:text-red-700">&times;</button>
    `
    this.containerTarget.appendChild(wrapper)
    wrapper.querySelector("input").focus()
  }

  remove(event) {
    event.preventDefault()
    event.currentTarget.closest("div").remove()
  }
}
